/**
 * Create by Alex
 * Description:
 *
 * ------ maintenance history ------
 * 2025/5/9 added to support impacted entity template
 */

import { businessConstants } from '../constants/business.constants';

export class ImpactedEntityTemplateConfig {
    name: string;
    type: string;
    setting: string;

    /**
     * Parse the impacted entity template config from response
     * @param serverResponse
     * @returns A array of impacted entity templates
     */
    static parse(serverResponse): Array<ImpactedEntityTemplateConfig> {
        const serverRes = serverResponse['entity-type-list'];
        if (!serverRes) {
            return null;
        }
        const impactedEntityTemplateConfig: Array<ImpactedEntityTemplateConfig> = new Array<ImpactedEntityTemplateConfig>();

        if (serverRes && serverRes.length > 0) {
            serverRes.forEach(item => {
                impactedEntityTemplateConfig.push(
                    {
                        name: item.name,
                        type: businessConstants.impactedConfigType.entityTemplate,
                        setting: item.AdhocFields
                    }
                );
            });
        }
        return impactedEntityTemplateConfig;
    }
}
